import { AxiosInstance } from "axios";
import ViaCepService from "../api/ViaCep.service";
import TradeService from "../api/Trade.service";
import TradeSearchService from "../api/TradeSearch.service";
import PrecatorioService from "../api/Precatorio.service";
import FeedbackService from "../api/Feedback.service";
import DocumentService from "../api/Document.service";
import CommonDomainService from "../api/CommonDomain.service";
import UserService from "../api/UserService";
import { UserAuthService } from "../api/UserAuth.service";
import { ITrade } from "../interfaces/trade/ITrade";
import CourtService from "../api/Court.service";
import CourtTypeService from "../api/CourtType.service";
import CourtTypeAccrualTypeService from "../api/CourtTypeAccrualType.service";
export default class ServiceApi {
  public restClient: AxiosInstance;
  public viaCepService: ViaCepService;
  public tradeService: TradeService<ITrade>;
  public precatorioService: PrecatorioService;
  public feedbackService: FeedbackService;
  public documentService: DocumentService;
  public commonDomainService: CommonDomainService;
  public userService: UserService;
  public userAuthService: UserAuthService;
  public tradeSearchService: TradeSearchService;
  public courtService: CourtService;
  public courtTypeService: CourtTypeService;
  public courtTypeAccrualTypeService: CourtTypeAccrualTypeService;
  
  constructor(restClient: AxiosInstance) {
    this.restClient = restClient;
    this.viaCepService = new ViaCepService();
    this.tradeService = new TradeService(restClient);
    this.precatorioService = new PrecatorioService(restClient);
    this.feedbackService = new FeedbackService(restClient);
    this.documentService = new DocumentService(restClient);
    this.commonDomainService = new CommonDomainService(restClient);
    this.userService = new UserService(restClient);
    this.userAuthService = new UserAuthService(this.restClient);
    this.tradeSearchService = new TradeSearchService(this.restClient);
    this.courtService = new CourtService(this.restClient);
    this.courtTypeService = new CourtTypeService(this.restClient);
    this.courtTypeAccrualTypeService = new CourtTypeAccrualTypeService(this.restClient);
  }
}



// WEBPACK FOOTER //
// ./src/services/model/ServiceApi.model.ts